import { useEffect, useState } from 'react';
import { getConnectivityStatus, subscribeConnectivity, type ConnectivityStatus } from './connectivityInfra';

export type { ConnectivityStatus };

export function useConnectivityStatus(): ConnectivityStatus {
  const [status, setStatus] = useState<ConnectivityStatus>({
    isOnline: true,
    isInternetReachable: true,
    type: null,
  });

  useEffect(() => {
    void getConnectivityStatus().then(setStatus);
    return subscribeConnectivity(setStatus);
  }, []);

  return status;
}
